import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import NavBar from './componance/NavBar';
import Footer from './componance/Footer';
import LoginModal from './componance/Login/LoginModal';
import PropertyImagesModal from './componance/Modal/PropertyImagesModal';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
import ContactPopupWithArrow from './componance/ContactPopupWithArrow';
import { useSearchParams } from 'react-router-dom';
import i18n from './i18n';
import PropertyListAdminHorizontal from './Propertylist/PropertyListAdminHorizontal';
import DetailModalPropertyAdmin from './componance/Modal/DetailModalPropertyAdmin';
import SearchForm from './componance/Search/SearchForm';
import DetailModalHeader from './componance/Modal/DetailModalHeader';
import EstimatedYield from './componance/Modal/EstimatedYield';

// ✅ Hook ตรวจสอบว่าหน้าจอเป็น mobile หรือไม่
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

function HomePage() {
  const [userId, setUserId] = useState(null);
  const [properties, setProperties] = useState([]);
  const [selectedType, setSelectedType] = useState('all');

  const [filteredProperties, setFilteredProperties] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null); 
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [, setFavoriteProperties] = useState([]);
  const [currency, setCurrency] = useState(localStorage.getItem('currency') || 'THB');
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  
  const [bedroomFilter, setBedroomFilter] = React.useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

const [searchResults, ] = useState([]);
 const [propertyStatus, setPropertyStatus] = useState('all');
  // ✅ ตรวจสอบว่าเป็น mobile ไหม
  const isMobile = useIsMobile();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded.userId || decoded.user_id);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => { document.body.style.overflow = 'auto'; };
  }, [isModalOpen]);

  // โหลด favorites จาก DB
  useEffect(() => {
    if (!userId) return;
    fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}`)
      .then(res => res.json())
      .then(data => setFavoriteProperties(data))
      .catch(err => console.error(err));
  }, [userId]);

  useEffect(() => {
    fetch('https://summerhousagentlive.onrender.com/api/properties')
      .then(response => response.json())
      .then(data => {
        const propsArray = Array.isArray(data) ? data : [];
        setProperties(propsArray);
        setFilteredProperties(propsArray);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  const openModal = React.useCallback((property) => {
    setSelectedProperty(property);
    setIsModalOpen(true);
    setSearchParams({ property: property.property_id });
  }, [setSearchParams]);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProperty(null);
    setSearchParams({});
  };

  useEffect(() => {
    const propId = searchParams.get('property');
    if (propId) {
      const prop = properties.find(p => p.property_id === Number(propId));
      if (prop) openModal(prop);
    }
  }, [searchParams, properties, openModal]);

  

  

  return (
    <div style={styles.container}>
      <NavBar currency={currency} setCurrency={setCurrency}/>

      {/* ✅ Layout responsive */}
      <div style={{
        display: 'flex',
        gap: '20px',
        alignItems: 'flex-start',
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        {/* ฝั่งซ้าย Search */}
        <div style={{ flex: 1 }}>
          <h1 style={styles.header}>{t('feature_admin')}</h1>
          <SearchForm
             properties={properties} // ต้องมี array ของ property แต่ละตัว {name, price, location, type, status, bedrooms}
              selectedLocations={selectedLocations}
              setSelectedLocations={setSelectedLocations}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              status={propertyStatus}
              setStatus={setPropertyStatus}
              bedroomFilter={bedroomFilter}
              setBedroomFilter={setBedroomFilter}
              setFilteredProperties={setFilteredProperties} // ต้องมี function สำหรับรับ filtered list
          />
        </div>

        {/* ฝั่งขวา รายการทรัพย์ */}
        <div style={{ flex: 3 }}>
      <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
      {t('property.total', { count: filteredProperties.length })}
    </p>
   <div id="searchResults">
          <PropertyListAdminHorizontal
            properties={[...filteredProperties].sort((a, b) => b.property_id - a.property_id)}
            openModal={openModal}
            currency={currency}
              results={searchResults}
          />
</div>
        </div>


        {isModalOpen && selectedProperty && (
                              <>
                                {/* พื้นหลังดำโปร่ง */}
                                <div
                                  style={{
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    width: '100vw',
                                    height: '100vh',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    zIndex: 1000,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                  onClick={closeModal}
                                />
        
                                {/* กล่อง Modal */}
                                <div
                                  style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    width: '95%',
                                    maxWidth: '700px',
                                    maxHeight: '90vh',
                                    overflowY: 'auto',
                                    boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
                                    position: 'fixed',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 1100,
                                    color: 'black',
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  >
                                  
                                  <DetailModalHeader
                                    closeModal={closeModal}
                                    selectedProperty={selectedProperty}
                                    t={t}
                                    i18n={i18n}
                                  />
                                  
                                  {/* Slider ภาพอสังหาริมทรัพย์ */}
                                  {selectedProperty.images && selectedProperty.images.length > 0 && (
                                    <div
                                      style={{
                                        width: '100%',
                                        maxWidth: '650px',
                                        height: '400px',
                                        margin: '20px auto 20px auto',
                                        overflow: 'hidden',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                      }}
                                    >
                                      <PropertyImagesModal
                                        images={selectedProperty.images}
                                        propertyName={selectedProperty.name}
                                      />
                                    </div>
                                  )}
        
                                  {/* รายละเอียดอสังหาริมทรัพย์ */}
                                  <DetailModalPropertyAdmin
                                    selectedProperty={selectedProperty}
                                    currency={currency}
                                    t={t}
                                  />
        
                                  {/* Estimated Yield Section */}
                                  {selectedProperty && (
                                    <EstimatedYield selectedProperty={selectedProperty} />
                                  )}
        
                                  {/* ปุ่มปิด Modal */}
                                  <button
                                    onClick={closeModal}
                                    style={{
                                      marginTop: '20px',
                                      backgroundColor: '#1a2e35',
                                      color: '#fff',
                                      padding: '10px 20px',
                                      border: 'none',
                                      borderRadius: '8px',
                                      cursor: 'pointer',
                                      fontWeight: '600',
                                      fontSize: '1rem',
                                      transition: 'all 0.3s',
                                      display: 'block',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                    }}
                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0f1c20')}
                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1a2e35')}
                                  >
                                    {t("close")}
                                  </button>
                                </div>
                              </>
                            )}
      </div>

      


      <Footer />
      {showLoginPopup && <LoginModal onClose={() => setShowLoginPopup(false)} />}
      <ContactPopupWithArrow />
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '100vh',
  },
  header: {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '20px',
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
    textShadow: '1px 1px 4px rgba(0,0,0,0.15)',
  
    borderBottom: '3px solid #dd9e2aff',
    paddingBottom: '8px',
    fontFamily: "'Roboto Condensed', 'Kanit', sans-serif",
  }
};

export default HomePage;
